import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { logError } from '../lib/errorHandler';

export default function useSectionLayout() {
  const [locations, setLocations] = useState<Record<string, string>>({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchLayout() {
      setIsLoading(true);
      setError(null);
      
      try {
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();

        const userId = session?.user?.id;
        
        if (!userId || sessionError) {
          setError('No active session');
          setIsLoading(false);
          return;
        }

        const { data, error: fetchError } = await supabase
          .from('customizations')
          .select('section_locations') 
          .eq('user_id', userId)
          .maybeSingle();

        if (fetchError) {
          throw fetchError;
        }

      const defaultLayout = {
  growth_instructions: 'loop',
  gold_file: 'loop',
  growth_opportunities: 'tools',
  goals: 'loop',
  community: 'tools',
  vision: 'tools'
};

if (data?.section_locations) {
  setLocations({ ...defaultLayout, ...data.section_locations });
} else {
  setLocations(defaultLayout);
}

      } catch (error) {
        logError(error, { context: 'useSectionLayout' });
        setError('Failed to load layout settings');
      } finally {
        setIsLoading(false);
      }
    }

    fetchLayout();
  }, []);

  return { locations, isLoading, error };
}